export class ExcelValidation {
    name: string;
    count: number;
    type: string;
    columnValidationName?: number;
    valid?: boolean;
    isValidated?: boolean = false;
}
